// SHOP GALLERY
const shopGalleryThumbs = document.querySelectorAll(
	".hoox-shop-checkout__gallery-thumbs .swiper-slide"
);

if (shopGalleryThumbs.length > 0) {
	var galleryThumbs = new Swiper(".hoox-shop-checkout__gallery-thumbs", {
		slidesPerView: 6,
		loop: true,
		spaceBetween: 6,
		watchSlidesProgress: true,

		breakpoints: {
			768: {
				spaceBetween: 30,
			},
		},
	});

	var galleryTop = new Swiper(".hoox-shop-checkout__gallery-main", {
		slidesPerView: 1,
		loop: true,

		thumbs: {
			swiper: galleryThumbs,
		},
	});
}
